<div class="modal-header">
  <h4 class="modal-title pull-left">{{tirSelectionne.nom}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="showModalCancel()"
    title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form id="myForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-12 form-group">
        <label for="selectEquipments">{{'DONNEE_SUIVI_OP.MOBILE_EQUIPEMENT' | translate }}</label>
        <ng-select placeholder="{{'DONNEE_SUIVI_OP.MOBILE_EQUIPEMENT' | translate }}" [items]="tabEquipments"
          bindLabel="displayName" [multiple]="true" [closeOnSelect]="false" [searchable]="false" name="selectEquipments"
          id="selectEquipments" [(ngModel)]="equipmentsSelectione" (change)="clearError()">
        </ng-select>
        @if (equipmentsNonRenseigne()) {
          <div class="alert alert-danger">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 form-group">
        <label for="selectDate">{{'MODALE_DONNEE_SUIVI.DATE' | translate}}</label>
        <div class="input-group">
          <input placeholder="{{'MODALE_DONNEE_SUIVI.DATE' | translate}}" type="text" class="form-control"
            [(ngModel)]="dateShift" name="selectDate" id="selectDate" [matDatepicker]="dateShiftPicker"
            onkeydown="return false" readonly autocomplete="off" [min]="dateDebProjet" [max]="todayDate"
            (click)="dateShiftPicker.open()" (focus)="dateShiftPicker.open()"
            (change)="clearError()" (dateChange)="getShiftForThisDate()" [disabled]="!shouldAddShift()">
            <mat-datepicker #dateShiftPicker></mat-datepicker>
            @if (dateShift && shouldAddShift()) {
              <div class="input-group-prepend">
                <button type="button" class="btn btn-outline-primary" (click)="nettoyerDates()"><i
                class=" fas fa-eraser"></i></button>
              </div>
            }
          </div>
          @if (dateNonRenseigne()) {
            <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
          }
        </div>

        <div class="col-md-6 form-group">
          <label for="selectTime">{{ 'GLOBAL.ROTATION' | translate }}</label>
          @if (shouldAddShift()) {
            <div>
              <ng-select name="selectTime" id="selectTime" placeholder="{{ 'GLOBAL.ROTATION' | translate }}"
                [items]="tabTime" bindLabel="label" bindValue="value" [(ngModel)]="timeSelectione" [addTag]="true"
                (change)="clearError()">
              </ng-select>
              @if (timeNonRenseigne()) {
                <div class="alert alert-danger">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
              }
            </div>
          }
          @if (!shouldAddShift()) {
            <div>
              <div class="form-control" style="background-color: #e9ecef;">{{ formatShiftLabel(timeSelectione) | translate
              }}</div>
            </div>
          }
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label for="selectOperator">{{'GLOBAL.OPERATORS' | translate}}</label>
          <ng-select name="selectOperator" id="selectOperator" [items]="tabOperateurs"
            placeholder="{{'GLOBAL.OPERATORS' | translate}}" bindLabel="nom" [(ngModel)]="operateurSelectionne">
          </ng-select>
        </div>
        <div class="col-md-6 form-group">
          <label for="selectEquipe">{{'DONNEE_SUIVI_OP.EQUIPE' | translate}}</label>
          <ng-select name="selectEquipe" id="selectEquipe" placeholder="{{'DONNEE_SUIVI_OP.EQUIPE' | translate }}"
            [items]="tabEquipes" bindLabel="nom" [(ngModel)]="equipeSelectionnee" [addTag]="true" (change)="clearError()">
          </ng-select>
          @if (equipeNonRenseigne()) {
            <div class="alert alert-danger">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
          }
        </div>
      </div>

      @if (erreurApi()) {
        <div class="alert alert-danger">{{'GLOBAL.ERREUR_MAJ_API' | translate }}</div>
      }

      <div class="btn-toolbar justify-content-between">
        <div class="btn-group" role="group">
          <button type="submit" form="myForm" class="btn btn-outline-success" style="margin-right:10px;">{{
          shouldAddShift() ? ('GLOBAL.AJOUTER' | translate) : ('GLOBAL.UPDATE' | translate) }}</button>
          @if (estModif) {
            <button type="button" class="btn btn-danger" (click)="showConfirmSuppr()">{{'GLOBAL.SUPPRIMER'
            | translate}}</button>
          }
        </div>
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-secondary" (click)="showModalCancel()">{{'GLOBAL.ANNULER' |
          translate}}</button>
        </div>
      </div>
    </form>

    <div class="modal fade" bsModal #modalConfirmAddOrUpdate="bs-modal" tabindex="-1" role="dialog"
      aria-labelledby="dialog-basic-name" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ 'GLOBAL.CONFIRM_SHIFT_UPDATE' | translate }}</h5>
          </div>
          @if (estModif) {
            <div class="modal-body">
              {{ 'GLOBAL.SHIFT_EXISTS' | translate:{ existingShiftTirId: existingShiftTirId(), existingShiftDate:
              existingShiftDate(), existingShiftTime: ( existingShiftTime() | translate ) } }}
            </div>
          }
          @if (!estModif) {
            <div class="modal-body">
              {{ 'GLOBAL.SHIFT_EXISTS_ADD' | translate:{ existingShiftTirId: existingShiftTirId(), existingShiftDate:
              existingShiftDate(), existingShiftTime: ( existingShiftTime() | translate ) } }}
            </div>
          }
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modalConfirmAddOrUpdate.hide()">{{'GLOBAL.ANNULER' |
            translate}}</button>
            <button type="button" class="btn btn-primary" (click)="onConfirmUpdate()">{{'GLOBAL.CONFIRMER' |
            translate}}</button>
          </div>
        </div>
      </div>
    </div>

  </div>